



































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';

import SideFilter from '@/components/SideFilter.vue';
import Gnb from '@/components/Gnb.vue';
import CreateGroup from '@/components/manageGroup/CreateGroup.vue';
import ModalExport from '@/components/ModalExport.vue';
import ModalImport from '@/components/ModalImport.vue';
import NotGroup from '@/components/NotGroup.vue';
import MobileHeader from '@/components/MobileHeader.vue';
import MobileFilter from '@/components/MobileFilter.vue';
import store from '@/store';

const namespace: string = 'manageGroup';

@Component({
  components: {
    SideFilter,
    Gnb,
    CreateGroup,
    ModalExport,
    ModalImport,
    NotGroup,
    MobileHeader,
    MobileFilter,
  },
})
export default class Container extends Vue {
  @Action('getGroups', { namespace }) c_getGroups!: any;
  @Action('getMe', { namespace }) c_getMe!: any;
  @Action('getProfile', { namespace: 'profile' }) c_getProfile!: any;
  @Action('getAvatar', { namespace: 'profile' }) c_getAvatar!: any;
  @Action('getMainLocations', { namespace }) c_getMainLocations!: any;
  @Action('getVendors', { namespace }) c_getVendors!: any;
  @Action('getManufacturers', { namespace }) c_getManufacturers!: any;
  @Action('getTypes', { namespace }) c_getTypes!: any;
  @Action('getMembers', { namespace }) c_getMembers!: any;
  @Action('getPurchaseOrders', { namespace: 'request' }) c_getPurchaseOrders!: any;
  @Action('getGrants', { namespace }) c_getGrants!: any;
  @Action('getSettings', { namespace: 'manageGroup' }) c_getSettings!: any;
  @Action('logOut', { namespace: 'auth' }) c_logOut!: any;

  @Getter('getterLastGroupId') c_getterLastGroupId!: string;
  @Getter('getterGroupsMemberships', { namespace }) c_getterGroupsMemberships!: any;
  @Getter('getterAuthUserId', { namespace: 'auth' }) c_getterAuthUserId!: string;
  @Getter('getterIsMobileFilterPageUp') c_getterIsMobileFilterPageUp!: boolean;

  @Mutation('SET_LAST_GROUP_ID', { namespace: 'auth' }) c_setLastGroupId!: any;

  public isDialogCreateLab: boolean = false;
  public isDialogManageLab: boolean = false;
  public dialogVisibleExport: boolean = false;
  public dialogVisibleImport: boolean = false;
  public isContainerOn: boolean = false;
  public isFilterOn: boolean = false;

  @Watch('$route', { immediate: true, deep: true })
  async onRouteChange(c: any, p: any) {
    try {
      const groupId: string = this.$route.params.groupId;

      // 가입된 그룹이 있는지 체크
      if (this.c_getterGroupsMemberships.length) {
        if (p && c.params.groupId !== p.params.groupId) {
          if (groupId && groupId !== 'welcome') {
            await this.c_getSettings(groupId);
            this.c_setLastGroupId(groupId);
            this.c_getMe(groupId);
            this.c_getMainLocations(groupId);
            this.c_getTypes(groupId);
            this.c_getVendors(groupId);
            this.c_getManufacturers(groupId);
            this.c_getMembers(groupId);
            this.c_getPurchaseOrders({
              groupId,
            });
            this.c_getGrants(groupId);
          } else {
            await this.$router.replace({
              name: 'ContentView',
              params: {
                groupId: this.c_getterGroupsMemberships[this.c_getterGroupsMemberships.length - 1]
                  .fkGroup.id,
              },
            });
          }
        }
      }
    } catch (e) {
      console.log('onRouteChange', e);
    }
  }

  async created() {
    // 그룹 접속시 최초 로딩창 실행
    const loading = this.$loading({
      background: 'rgba(255, 255, 255, 1)',
    });

    try {
      const groupId: string = this.$route.params.groupId;
      const userId: string = this.c_getterAuthUserId;

      // 그룹정보, 프로필, 아바타 데이터 불러오기
      // 그룹정보 데이터 불러오기
      await this.c_getGroups();
      this.c_getProfile(userId);
      this.c_getAvatar(userId);

      // 가입된 그룹이 있는지 체크
      if (this.c_getterGroupsMemberships.length) {
        if (groupId && groupId !== 'welcome') {
          await this.c_getSettings(groupId);
          this.c_setLastGroupId(groupId);
          this.c_getMe(groupId);
          this.c_getMainLocations(groupId);
          this.c_getTypes(groupId);
          this.c_getVendors(groupId);
          this.c_getManufacturers(groupId);
          this.c_getMembers(groupId);
          this.c_getPurchaseOrders({
            groupId,
          });
          this.c_getGrants(groupId);
        } else {
          await this.$router.replace({
            name: 'ContentView',
            params: {
              groupId: this.c_getterGroupsMemberships[this.c_getterGroupsMemberships.length - 1]
                .fkGroup.id,
            },
          });
        }
      } else {
        this.isDialogCreateLab = true;
      }

      // 로딩창 종료
      this.isContainerOn = true;
      loading.close();
    } catch (e) {
      this.isContainerOn = true;
      loading.close();
      if (e.response.data.error.code === 'ACCESS_DENIED') {
        localStorage.removeItem('users');
        delete store.state.auth.isAuth;
        await this.$router.push('/login');
      } else if (e.response.data.error.code === 'NO_GROUP_DATA') {
        delete store.state.auth.lastGroupId;
        await this.$router.push('/groups');
      } else if (e.response.data.error.code === 'NO_MEMBERSHIP_DATA') {
        delete store.state.auth.lastGroupId;
        await this.$router.push('/groups/welcome/inventory');
      } else {
        await this.$router.push('/404');
      }
    }
  }

  onCreateModalClose() {
    this.isDialogCreateLab = false;
  }

  mounted() {
    this.$root.$on('createLab', (bool: boolean) => {
      this.isDialogCreateLab = bool;
    });
    this.$root.$on('closeCreateLab', (bool: boolean) => {
      this.isDialogCreateLab = bool;
    });
    this.$root.$on('g_emitManageGroup', (bool: boolean) => {
      this.isDialogManageLab = bool;
    });
    this.$root.$on('isExportModal', (bool: boolean) => {
      this.dialogVisibleExport = bool;
    });
    this.$root.$on('isImportModal', (bool: boolean) => {
      this.dialogVisibleImport = bool;
    });
    this.$root.$on('createGroup', (bool: boolean) => {
      this.isDialogManageLab = bool;
    });
  }
}
